import type { ActivityEvent, Branch, DailySale, EventType } from './domain';
import { deleteValue, getAll, putValue, setSetting, setting } from './db';

let flushing = false;

async function identity() {
  let deviceId = await setting('deviceId');
  if (!deviceId) { deviceId = crypto.randomUUID(); await setSetting('deviceId', deviceId); }
  let sessionId = sessionStorage.getItem('daily-session');
  if (!sessionId) { sessionId = crypto.randomUUID(); sessionStorage.setItem('daily-session', sessionId); }
  return { deviceId, sessionId };
}

export async function recordEvent(eventType: EventType, payload: Record<string, unknown>, branchId?: string) {
  const ids = await identity();
  const event: ActivityEvent = {
    eventId: crypto.randomUUID(), ...ids, branchId, eventType,
    occurredAt: new Date().toISOString(), payload
  };
  await putValue('outbox', event);
  void flushOutbox();
  return event;
}

export async function flushOutbox() {
  if (flushing || !navigator.onLine) return false;
  flushing = true;
  try {
    const [branches, sales, events] = await Promise.all([
      getAll<Branch>('branches'), getAll<DailySale>('sales'), getAll<ActivityEvent>('outbox')
    ]);
    if (!events.length && !branches.length) return true;
    const response = await fetch('/api/sync', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ branches, sales, events })
    });
    if (!response.ok) return false;
    const result = await response.json() as { acceptedEventIds?: string[] };
    await Promise.all((result.acceptedEventIds ?? events.map((event) => event.eventId)).map((id) => deleteValue('outbox', id)));
    await setSetting('lastSync', new Date().toISOString());
    return true;
  } catch {
    return false;
  } finally {
    flushing = false;
  }
}
